// extracted by mini-css-extract-plugin
export default {"loading-state":"AX58w"};